import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Shield } from 'lucide-react';

const CONSENT_KEY = 'shamrock_cookie_consent';

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setShow(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-consent-overlay" style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '16px',
    }}>
      <div data-testid="cookie-consent-modal" style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        maxWidth: '480px',
        width: '100%',
        padding: '32px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
          <Shield size={28} style={{ color: '#065f46', flexShrink: 0 }} />
          <h2 style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '24px', color: '#065f46', letterSpacing: '1px', margin: 0 }}>
            Cookie Usage
          </h2>
        </div>

        <p style={{ fontFamily: "'Manrope', sans-serif", fontSize: '14px', color: '#4b5563', lineHeight: '1.6', marginBottom: '12px' }}>
          The Shamrock uses cookies as a backup authentication method to keep you signed in across sessions.
        </p>

        {showDetails ? (
          <div style={{
            backgroundColor: '#f0fdf4',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '16px',
            border: '1px solid #d1fae5',
          }}>
            <p style={{ fontFamily: "'Manrope', sans-serif", fontSize: '13px', color: '#065f46', fontWeight: 700, marginBottom: '8px' }}>
              What we use cookies for:
            </p>
            <ul style={{ fontFamily: "'Manrope', sans-serif", fontSize: '13px', color: '#374151', lineHeight: '1.8', paddingLeft: '20px', margin: 0 }}>
              <li><strong>Session authentication</strong> — A secure, HTTP-only cookie stores your login session as a backup to your primary auth token.</li>
              <li><strong>No tracking</strong> — We do not use analytics cookies, advertising cookies, or any third-party tracking.</li>
              <li><strong>No personal data</strong> — The cookie contains only a random session ID, not your name, email, or any personal information.</li>
            </ul>
            <p style={{ fontFamily: "'Manrope', sans-serif", fontSize: '13px', color: '#6b7280', marginTop: '12px', marginBottom: 0 }}>
              If you decline cookies, the app will still work normally using your browser's local storage for authentication. Cookies just provide an extra layer of session reliability.
            </p>
          </div>
        ) : (
          <button
            data-testid="cookie-learn-more"
            onClick={() => setShowDetails(true)}
            style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: '13px',
              color: '#059669',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginBottom: '16px',
              display: 'block',
              textDecoration: 'underline',
            }}
          >
            Learn more about our cookie usage
          </button>
        )}

        <div style={{ display: 'flex', gap: '12px' }}>
          <Button
            data-testid="cookie-accept-btn"
            onClick={handleAccept}
            className="btn-primary flex-1"
            style={{ borderRadius: '8px', padding: '10px 0' }}
          >
            Accept Cookies
          </Button>
          <Button
            data-testid="cookie-decline-btn"
            onClick={handleDecline}
            variant="outline"
            className="flex-1"
            style={{ borderRadius: '8px', padding: '10px 0', fontFamily: "'Manrope', sans-serif" }}
          >
            Decline
          </Button>
        </div>
      </div>
    </div>
  );
}
